import { Injectable } from 'angular-ts-decorators';

import { IAnchorBarItem } from '../models/anchor-bar-item';

export interface IAnchorBarService {
  add(item: IAnchorBarItem): void;
  getAnchors(): IAnchorBarItem[];
  remove(item: IAnchorBarItem): void;
}

@Injectable('anchorBarService')
export class AnchorBarService implements IAnchorBarService {
  public static $inject: ReadonlyArray<string> = [];

  private readonly anchors: IAnchorBarItem[] = [];

  public add(item: IAnchorBarItem): void {
    this.anchors.push(item);
  }

  public getAnchors(): IAnchorBarItem[] {
    return this.anchors;
  }

  public remove(item: IAnchorBarItem): void {
    const index: number = this.anchors.indexOf(item);

    if (index === -1) {
      return;
    }

    this.anchors.splice(index, 1);
  }
}
